import { Icon } from '@mui/material';
import { createElement } from 'react';

export const extractIconAndName = (iconId: string) => {
    const temp = iconId.split('/');
    return temp[2].split(';');
};

const convertIconName = (iconName: string) => {
    let data = iconName ? iconName.match(/[A-Z][a-z]+/g) : null;
    let newData = '';
    data &&
        data.forEach((item) => {
            newData = `${newData}${item.toLowerCase()}_`;
        });
    return newData.slice(0, newData.length - 1);
};

export const resolveIcon = (iconId: string | undefined, defaultIcon: any, props: any = {}) => {
    const materialIconRegularExpression = /@material-ui\/icons\/.+/;

    if (iconId && materialIconRegularExpression.test(iconId)) {
        const dataName = extractIconAndName(iconId);
        const iconName = dataName[0];
        const color = dataName.length > 1 ? dataName[1] : null;
        return createElement(
            Icon,
            {
                ...(props ? props : {}),
                ...(color
                    ? props && props.hasOwnProperty('style')
                        ? { style: { ...props.style, color } }
                        : { style: { color } }
                    : {}),
            },
            convertIconName(iconName),
        );
    } else {
        return createElement(Icon, { ...(props ? props : {}) }, convertIconName(defaultIcon));
    }
};
